<template lang="pug">
div
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title Calibrator Accessory Kits

        router-link.section(to='/en/products/pdaccessories/calibratorcase')
            .column-container
                .column.flexgrow
                    .producttitle CAL-IEC Accessory Kit
                    .subtitle Robust carrying case with cables, clamps, and connectors for the CAL-IEC calibrator
                    ul
                        li Practical accessory set
                        li Ready to use for laboratory and field applications
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case.webp')
                        img( src='@/assets/photos/for_product_overview/CAL-IEC-Case.png', width="60%", alt='Calibrator Case for CAL-IEC Calibrator', title='Calibrator Case for CAL-IEC Calibrator')

        router-link.section(to='/en/products/pdaccessories/cal-uhf-accessory-kit')
            .column-container
                .column.flexgrow
                    .producttitle CAL-UHF Accessory Kit
                    .subtitle Robust accessory case with cables and connectors for the CAL-UHF calibrator
                    ul
                        li Practical accessory set
                        li Ready to use for laboratory and field applications
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                        img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='60%', alt='CAL-UHF Accessory Kit', title='CAL-UHF Accessory Kit')

    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title Kalibrator Zubehörsets

        router-link.section(to='/de/products/pdaccessories/calibratorcase')
            .column-container
                .column.flexgrow
                    .producttitle CAL-IEC Zubehörset
                    .subtitle Robuster Tragekoffer mit Kabeln, Klemmen und Adaptern für den CAL-IEC Kalibrator
                    ul
                        li Praxisgerecht zusammengestelltes Zubehör
                        li Sofort einsatzbereit für Labor- und Feldeinsätze
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case.webp')
                        img( src='@/assets/photos/for_product_overview/CAL-IEC-Case.png', width="60%", alt='Calibrator Case for CAL-IEC Calibrator', title='Calibrator Case for CAL-IEC Calibrator')

        router-link.section(to='/de/products/pdaccessories/cal-uhf-accessory-kit')
            .column-container
                .column.flexgrow
                    .producttitle CAL-UHF Zubehörset
                    .subtitle Robuster Zubehörkoffer mit Kabeln und Anschlüssen für den CAL-UHF Kalibrator
                    ul
                        li Praxisgerecht zusammengestelltes Zubehör
                        li Sofort einsatzbereit für Labor- und Feldeinsätze
                .column.alignright
                    picture.overview-product-picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                        img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='60%', alt='CAL-UHF Zubehörset', title='CAL-UHF Zubehörset')

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Kalibratorkoffer",
            description: "Tragekoffer für Signalgeneratoren und Kalibratoren",
        },
        en: {
            title: "BSS | Calibrator Case",
            description: "Hard-carry-case for Signal Generators and Calibrators",
        },
    },
};
</script>

<style lang="sass" scoped>
@import '@/assets/sass/product_overview.sass'
</style>